import React, { Component } from 'react';
//import './ScreenInvaders.css';
import Invaders from '../../backgrounds/Invaders';
import './ScreenInvaders.css';

class BlockInvaders extends Component
{
  render()
  {
      return (
        <div className="index-block bg-black" id="BlockInvaders">
          <Invaders />
          <div className="container">
            <div className="row main">
              <div className="col-md-8">
                <h1 className="color-white">
                  Your idea - it's great, it's true.
                </h1>
                <h3 className="scope text-blue">Want to show it to the world in an exceptional way?
                Then read on!</h3>
              </div>
            </div>
          </div>
        </div>
      )
  }
}

export default BlockInvaders;



// WEBPACK FOOTER //
// ./src/screens/screenInvaders/BlockInvaders.js